<template>
  <mdb-carousel class="wr" :interval="5000" slide :items="items" controlls indicators />
</template>

<script>
export default {
  name: 'CarouselMain',
  data() {
    return {
      items: [
        {
          img: true,
          src: '/static/images/mainimg/halfmain2.png',
        },
        {
          img: true,
          src: '/static/images/mainimg/halfmain3.png',
        },
        {
          img: true,
          src: '/static/images/mainimg/halfmain6.png',
        },
        {
          img: true,
          src: '/static/images/mainimg/halfmain8.png',
        },
      ],
    };
  },
};
</script>

<style scoped>
.wr {
  max-width: 100%;
  margin: 0 0px;
  padding: 0 0px;
}

.li.active.primary {
  opacity: 1;
  background-color: #fba0fb;
}

.primary{
  background-color: #fba0fb;
}

.carousel .carousel-indicators .li.active.primary{
  width: .625rem;
  height: .625rem;
  cursor: pointer;
  border-radius: 50%;
  background-color: #fba0fb;
}

.carousel-indicators li {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  -ms-flex: 0 1 auto;
  -webkit-box-flex: 0;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fba0fb;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: .5;
  -webkit-transition: opacity .6s ease;
  transition: opacity .6s ease;
}
</style>
